import { spec, specTrack } from './spec';
import {
  createSignal,
  createEffect,
  createContext,
  useContext,
  onMount,
  on,
  unwrap,
} from 'solid-js';
import { assign, set } from 'radash';
import { theme_schema } from 'schemas';
import { create } from 'domain';
import { kebabize } from 'utils';



// Convert integer numbers to CSS px strings; leave others as strings
const toCssValue = (v: any) =>
  typeof v === 'number' && Number.isInteger(v) ? `${v}px` : String(v);

const themeglob = import.meta.glob('../css/*/*');

const ThemeContext = createContext();
export const useTheme = () => {
  return useContext(ThemeContext);
};

export const ThemeProvider = (props) => {
  const [theme, setTheme] = createSignal({});
  const [overrides, setOverrides] = createSignal({});
  const [preset, setPreset] = createSignal({});

  const updatePreset = (specPreset = 'default') => {
    const presets = `../css/${specPreset}/presets.json`;
    if (themeglob[presets]) {
      themeglob[presets]().then(({ default: p }) => {
        setPreset({ ...p });
      });
    } else {
      console.warn(`Theme preset '${specPreset}' not found, using default`);
      updatePreset('default');
    }
  };

  // Track preset changes - use defer: false to run on mount
  createEffect(
    on(() => props.theme?.preset, (presetName) => {
      updatePreset(presetName || 'default');
    }, { defer: false }),
  );

  // Track style overrides
  createEffect(
    on(() => specTrack(props.theme?.style), () => {
      setOverrides(props.theme?.style || {});
    }, { defer: false }),
  );

  // Apply theme CSS variables when preset or overrides change
  createEffect(() => {
    const merged =assign( preset(), overrides() );
    setTheme(merged);
    const r = document.querySelector('body')?.style;
    if (!r) return;
    for (let key in merged) {
      for (let subkey in merged[key]) {
        const prop = '--' + key + '-' + kebabize(subkey);
        r.setProperty(prop, toCssValue(merged[key][subkey]));
      }
    }
  });

  return (
    <ThemeContext.Provider value={theme}>
      {props.children}
    </ThemeContext.Provider>
  );
};
